import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { Alert } from "react-bootstrap";
import { authService } from "../../../Services/auth.service";
import { validateEmail } from "../../../Services/string.service";
import { FaSignInAlt, FaChevronDown } from "react-icons/fa";
import { usersService } from "../../../Services/users.service";
import { storage } from "../../../Services/storage.service";
import { storageKeys } from "../../../Constants/storage.key";

import "../artifacts/css/login.css";

export default function Access(props) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [alertShow, setAlertShow] = useState({ show: false, message: "" });
  const [accessPayload, setAccess] = useState({});
  const [buttonLoading, setButtonLoading] = useState(false);
  const [loginOptions, setLoginOptions] = useState([]);
  const [selectedUser, setSelectedUser] = useState("");

  const handleField = (field, value) => {
    accessPayload[field] = value;
    setAccess(accessPayload);
    setAlertShow({ show: false, message: "" });
  };

  const validate = () => {
    if (accessPayload) {
      if (accessPayload["email"]) {
        if (!validateEmail(accessPayload["email"])) {
          setAlertShow({ show: true, message: t("ERRORS.EMAIL_FORMAT") });
          return false;
        }
      }
      if (!accessPayload["email"] || !accessPayload["pass"]) {
        setAlertShow({
          show: true,
          message: t("ERRORS.EMAIL_OR_PASS_INVALID"),
        });
        return false;
      }
      return true;
    }
    console.warn("Nenhum dado Fornecido para o login!");
    return false;
  };

  const handleLoginUsers = () => {
    if (selectedUser) {
      const selected = loginOptions.filter((x) => x.userId == selectedUser);
      login(selected[0]);
    } else {
      setAlertShow({ show: true, message: t("ERRORS.USER_NOT_SELECTED") });
    }
  };

  // 👇️ Execução do Login
  const fetchAuthorizeds = async (customPayload = null) => {
    setAlertShow(false);


    const payload = customPayload ?? {
      licenseId: 4759,
      login: accessPayload.email,
      pass: accessPayload.pass,
      deviceId: "string"
    };

    // Validação manual (em vez de usar validate())
    if (!payload.login || !payload.pass || !validateEmail(payload.login)) {
      setAlertShow({
        show: true,
        message: t("ERRORS.EMAIL_OR_PASS_INVALID"),
      });
      props.onLoading?.(false);
      return;
    }

    if (!accessPayload["email"] && customPayload) {
      accessPayload["email"] = customPayload.login;
      accessPayload["pass"] = customPayload.pass;
    }

    try {
      setButtonLoading(true);

      const logins = await authService.authorizedLogin(payload);

      if (logins?.length === 1) {
        await login({ ...logins[0], email: payload.login, pass: payload.pass });
      } else if (logins?.length > 1) {
        setLoginOptions(logins);
        setSelectedUser(logins[0].userId);
      } else {
        throw new Error(t("ERRORS.USER_NOT_FOUND"));
      }
    } catch (error) {
      console.error("Erro no fetchAuthorizeds:", error);
      setAlertShow({
        show: true,
        message: error.message || t("ERRORS.LOGIN_FAILED"),
      });
    } finally {
      setButtonLoading(false);
      props.onLoading?.(false);
    }
  };

  const login = async (data) => {
    try {
      var payload = {
        licenseId: 4759,
        login: accessPayload.email,
        pass: accessPayload.pass,
        userId: data.userId,
        // eslint-disable-next-line
        userLogId: data.userLogId,
        clientId: data.clientId,
      };

      setButtonLoading(true);
      var authorized = await authService.auth(payload);

      if (authorized) {
        const userLogged = await usersService.users();
        if (userLogged) {
          setAlertShow({
            show: false,
            message: "",
          });
          storage.save(storageKeys.settings, data);
          
          // Carregar avatar após login bem-sucedido
          try {
            await usersService.fetchAvatarImage();
          } catch (avatarError) {
            console.log("Avatar não encontrado ou erro ao carregar");
          }
          
          navigate("/home");
        } else {
          setAlertShow({
            show: true,
            message: t("ERRORS.EMAIL_OR_PASS_INVALID"),
          });
        }
      } else {
        setAlertShow({
          show: true,
          message: t("ERRORS.USER_NOT_FOUND"),
        });
      }
    } catch (error) {
      setAlertShow(true);
      console.log(error);
    } finally {
      setButtonLoading(false);
      props.onLoading(false);
    }
  };

  const remember = async () => {
    props.showAccessSection(false);
  };

  useEffect(() => {
    const keyDownHandler = (event) => {
      console.log("User pressed: ", event.key);

      if (event.key === "Enter") {
        event.preventDefault();

        login();
      }
    };

    document.addEventListener("keydown", keyDownHandler);

    return () => {
      document.removeEventListener("keydown", keyDownHandler);
    };
  }, []);

  const goBack = () => {
    setSelectedUser("");
    setLoginOptions([]);
  };

  useEffect(() => {
    const tryAutoLogin = async () => {
      const hash = window.location.hash;
      const hasParams = hash.includes("?");

      if (!hasParams) {
        props.onLoading?.(false);
        return;
      }

      const [, queryString] = hash.split("?");
      const params = new URLSearchParams(queryString);
      const email = params.get("p1");
      const pass = params.get("p2");

      if (!email || !pass || !validateEmail(email)) {
        setAlertShow({
          show: true,
          message: "Parâmetros inválidos na URL.",
        });

        window.history.replaceState(
          null,
          "",
          window.location.pathname + "#/login"
        );

        props.onLoading?.(false);
        return;
      }

      setAccess({ email, pass });
      setButtonLoading(true);

      try {
        await fetchAuthorizeds({ login: email, pass });
      } catch (err) {
        console.error("Erro no login automático:", err);
        setAlertShow({
          show: true,
          message: err.message || "Erro no login automático.",
        });
        // setTimeout(() => {
        //   window.location.hash = "#/login";
        // }, 2500);
      } finally {
        setButtonLoading(false);
      }
    };

    tryAutoLogin();
  }, []);

  return (
    <React.Fragment>
      <div className="no-loading">
        <span
          className="login100-form-title p-b-43"
          style={{ color: "#00698B" }}
        >
          {" "}
          {t("LOGIN.LOGIN")}
        </span>

        <Alert
          variant="danger"
          style={alertShow.show ? { display: "block" } : { display: "none" }}
        >
          <strong>{t("COMMON.ATTENTION")}</strong>
          <p>{alertShow.message}</p>
        </Alert>

        {loginOptions.length > 1 ? (
          <>
            <div className="div-text-center">
              <span className="login100-form-desc">
                {t("LOGIN.SELECT_ACCOUNT")}
              </span>
            </div>
            <div className="wrap-input100 validate-input">
              <select
                name="logins"
                className="input100"
                value={selectedUser}
                onChange={(e) => setSelectedUser(e.target.value)}
              >
                {loginOptions.map((item, index) => (
                  <option key={index} value={item.userId}>
                    {item.userLogName}
                  </option>
                ))}
              </select>
              <span className="focus-input100"></span>
              <span className="label-input100">{t("LOGIN.ACCOUNTS")}</span>
              <span className="custom-icon">
                <FaChevronDown />
              </span>
            </div>

            <div className="flex-sb-m w-full p-t-3 p-b-32 p-2">
              <div onClick={goBack} style={{ cursor: "pointer" }}>
                {t("LOGIN.BACK")}{" "}
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="wrap-input100 validate-input">
              <input
                className="input100"
                type="email"
                id="email"
                name="accessEmail"
                autoComplete="off"
                onChange={(e) => handleField("email", e.target.value)}
              />
              <span className="focus-input100"></span>
              <span className="label-input100">{t("LOGIN.USER")}</span>
            </div>

            <div className="wrap-input100 validate-input">
              <input
                className="input100 input-pass"
                type="password"
                id="pass"
                name="pass"
                onChange={(e) => handleField("pass", e.target.value)}
                autoComplete="off"
              />
              <span className="focus-input100"></span>
              <span className="label-input100">{t("LOGIN.PASSWORD")}</span>
            </div>

            <div className="flex-sb-m w-full p-t-3 p-b-32 p-1">
              <div onClick={remember} style={{ cursor: "pointer" }}>
                <span style={{color: "#009E80"}}>
                  {t("LOGIN.FORGOT_PASSWORD")}{" "}

                </span>
              </div>
            </div>
          </>
        )}

        <div className="container-login100-form-btn">
          <button
            className="login100-form-btn"
            type="button"
            onClick={() => {
              if (loginOptions.length > 0) {
                handleLoginUsers();
              } else {
                fetchAuthorizeds();
              }
            }}
            disabled={buttonLoading}
          >
            <>
              {buttonLoading && (
                <div className="spinner-border" style={{ marginRight: "10px" }}>
                  <span className="visually-hidden">{t("LOGIN.LOADING_TEXT")}</span>
                </div>
              )}
              {!buttonLoading && (
                <FaSignInAlt style={{ marginRight: "10px" }} />
              )}
            </>

            <span>{buttonLoading ? t("LOGIN.ACCESSING") : t("LOGIN.ACCESS")}</span>
          </button>
        </div>
      </div>
    </React.Fragment>
  );
}